import { render } from "./OdsSpinner.vue?vue&type=template&id=4b57cfd9&scoped=true"
import script from "./OdsSpinner.vue?vue&type=script&lang=js"
export * from "./OdsSpinner.vue?vue&type=script&lang=js"

import "./OdsSpinner.vue?vue&type=style&index=0&id=4b57cfd9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b57cfd9"]])

export default __exports__